import { Tab, Tabs } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/app/hooks';
import { getTicketStatistics } from 'src/store/actions/ticketActions';
import { TicketStatus } from 'src/store/models/Ticket';

import { DateRange } from '../../../store/models/Stats';
import classes from './Statistics.module.scss';
import StatisticsItem from './StatisticsItem/StatisticsItem';

interface TabInterface {
  label: string;
  value: DateRange;
}

const Statistics: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [tabValue, setTabValue] = useState<DateRange>(DateRange.WEEKLY);

  const statsTabs: TabInterface[] = [
    { label: t('dashboard:last_week'), value: DateRange.WEEKLY },
    {
      label: t('dashboard:last_month'),
      value: DateRange.MONTHLY,
    },
    { label: t('dashboard:last_year'), value: DateRange.YEARLY },
  ];

  useEffect(() => {
    dispatch(
      getTicketStatistics({ range: tabValue, status: TicketStatus.TO_DO })
    );
    // eslint-disable-next-line
  }, [tabValue]);

  return (
    <div>
      <h4>{t('device:statistics')}</h4>
      <Tabs
        className={classes.Tabs}
        value={tabValue}
        onChange={(_, value) => setTabValue(value)}
        TabIndicatorProps={{
          className: classes.SelectedTab,
        }}
      >
        {statsTabs.map((tab, i) => (
          <Tab key={i} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
      <div className={classes.StatContainer}>
        <StatisticsItem
          status={TicketStatus.UNASSIGNED}
          range={tabValue}
          title={t('dashboard:issues_reported')}
        />
        <StatisticsItem
          status={TicketStatus.RESOLVED}
          range={tabValue}
          title={t('dashboard:tickets_resolved')}
        />
        <StatisticsItem
          status={TicketStatus.IN_PROGRESS}
          range={tabValue}
          title={t('dashboard:tickets_in_progress')}
        />
      </div>
    </div>
  );
};

export default Statistics;
